import * as React from "react";

// component
import Grid from "./Grid";

// interfaces
import { GridSchema } from "./interfaces";
import { IDispatcher } from "../../helpers/Dispatcher";
import { IControlError } from "../../../core/Controls";

// static
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";
import "react-phone-input-2/lib/style.css";

export function createGrid(
	schema: any,
	// TODO: abstract type any
	api: any,
	dispatcher: IDispatcher = null,

	error: IControlError | undefined,
	visited: boolean,
	// TODO: abstract type any
	opts: any,
	// TODO: abstract type any
	information: any,
	values: Array<{ controlid: string; value: unknown }>,
	rowIndex: number
): React.ReactElement<any> {
	return (
		<Grid
			schema={schema as GridSchema}
			api={api}
			error={error}
			visited={visited}
			dispatcher={dispatcher}
			opts={opts}
			information={information}
			values={values}
			rowIndex={rowIndex}
		/>
	);
}
